module.exports = __webpack_public_path__ + "img/crown1.4f04bd37.svg";